// extracted by mini-css-extract-plugin
export var quillEditor = "_nb-1";
export var variable = "_nb-0";